module.exports = __webpack_public_path__ + "img/client-tie.8220b72c.svg";